import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=27c65b8c&scoped=true"
import script from "./FilterCard.vue?vue&type=script&lang=js"
export * from "./FilterCard.vue?vue&type=script&lang=js"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=27c65b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c65b8c",
  null
  
)

export default component.exports